const OBUUidLookup = () => {
  return <>UID Lookup</>
}

export default OBUUidLookup;